export const MODEL_META = {
  "claude-opus-5-5": { label: "Claude Opus 5.5", short: "Opus", accent: "purple" },
  "claude-sonnet-5-5": { label: "Claude Sonnet 5.5", short: "Sonnet", accent: "amber" },
  "claude-haiku-5-5": { label: "Claude Haiku 5.5", short: "Haiku", accent: "cyan" },
  "gpt-5.4": { label: "GPT-5.4", short: "GPT", accent: "emerald" },
  "gemini-3.1-pro-preview": { label: "Gemini 3.1 Pro", short: "Gemini", accent: "indigo" },
};

export const ACCENT = {
  emerald: { bg: "bg-emerald-500/10", text: "text-emerald-400", border: "border-emerald-500/25", dot: "bg-emerald-400" },
  amber: { bg: "bg-amber-500/10", text: "text-amber-400", border: "border-amber-500/25", dot: "bg-amber-400" },
  purple: { bg: "bg-purple-500/10", text: "text-purple-400", border: "border-purple-500/25", dot: "bg-purple-400" },
  indigo: { bg: "bg-indigo-500/10", text: "text-indigo-400", border: "border-indigo-500/25", dot: "bg-indigo-400" },
  cyan: { bg: "bg-cyan-500/10", text: "text-cyan-400", border: "border-cyan-500/25", dot: "bg-cyan-400" },
};

export function metaFor(id) {
  return MODEL_META[id] || { label: id, short: id, accent: "emerald" };
}
